<template>
	<div class="user-account">
		<spinner v-if="user.loading || accounts.loading"/>
		<div class="wrapper" v-else>
			<avatar-picture-user/>
			<div class="info">
				<div class="name">{{ account.name }}</div>
				<!-- <div class="account-type">Personal account</div> -->
				<change-account/>
			</div>
		</div>
	</div>
</template>

<script>
import ChangeAccount from './ChangeAccount'
export default {
	components: {
		ChangeAccount
	},
	computed: {
		user () {
			return this.$store.state.user
		},
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		},
		accounts () {
			return this.$store.state.accounts
		},
		account () {
			return this.$store.getters.getAccount(this.selectedAccount)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/account/UserAccount.vue